// Hulpfuncties om geneste vertaalobjecten om te zetten naar/van een platte key→waarde-map.

export function flatten(obj: unknown, prefix = ''): Record<string, string> {
    const _out: Record<string, string> = {};
    const _record = (obj ?? {}) as Record<string, unknown>;

    for (const _key of Object.keys(_record)) {
        const _val = _record[_key];
        const _path = prefix ? `${prefix}.${_key}` : _key;

        if (_val && typeof _val === 'object' && !Array.isArray(_val)) {
            Object.assign(_out, flatten(_val, _path));
        } else {
            _out[_path] = String(_val);
        }
    }
    return _out;
}

export function unflatten(flat: Record<string, string>): Record<string, unknown> {
    const _out: Record<string, unknown> = {};

    for (const _path of Object.keys(flat)) {
        const _parts = _path.split('.');
        let _node = _out;

        _parts.forEach((_p, _i) => {
            if (_i === _parts.length - 1) {
                _node[_p] = flat[_path];
            } else {
                _node[_p] = (_node[_p] as Record<string, unknown>) ?? {};
                _node = _node[_p] as Record<string, unknown>;
            }
        });
    }
    return _out;
}
